import { render, staticRenderFns } from "./CcAnchorChip.vue?vue&type=template&id=09929095&scoped=true"
import script from "./CcAnchorChip.vue?vue&type=script&setup=true&lang=js"
export * from "./CcAnchorChip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CcAnchorChip.vue?vue&type=style&index=0&id=09929095&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09929095",
  null
  
)

export default component.exports